import {
  TechDocChecklistPage,
  TechDocWizardPage,
  TechDocPage,
} from '../containers/pages';
import { ALLETRAMP_VIDEO_URL } from '../constants';
import { SelectModelPage } from '../containers/selectModelPage';

const gettingStartedPath = '/getting-started/';
const cloudEnablementPath = `${gettingStartedPath}cloud-enablement/`;
export const gettingStarted = () => {
  let config = [];
  config = gettingStartedConfig();
  return config;
};
function gettingStartedConfig() {
  const menuItemArray = [
    {
      path: '/getting-started',
      menuText: 'gettingStarted',
      exact: true,
      redirectTo: '/getting-started/select-model',
      submenuItems: [
        {
          path: '/getting-started/select-model',
          menuText: 'selectStorageTier',
          pageName: 'selectStorageTier',
          exact: true,
          component: SelectModelPage,
          pageProps: {},
        },
        {
          path: cloudEnablementPath,
          menuText: 'cloudenablement',
          exact: true,
          redirectTo: `${cloudEnablementPath}1`,
        },
        {
          path: `${cloudEnablementPath}:step`,
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cloudenablement',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Create User Account',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
                steptitle: 'Create Workspace',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
                steptitle: 'Deploy Data Services Cloud Console',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
                steptitle: 'Assign Administrator',
              },
            ],
          },
        },
        {
          path: '/getting-started/checklist',
          menuText: 'preInstallationVME',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
      ],
    },
    {
      path: '/physical-install',
      menuText: 'physicalInstallation',
      exact: true,
      redirectTo: '/physical-install/plan',
      submenuItems: [
        {
          path: '/physical-install/plan',
          menuText: 'plan',
          exact: true,
          component: TechDocPage,
        },
        {
          path: '/physical-install/unbox',
          menuText: 'unboxField',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl: ALLETRAMP_VIDEO_URL.FIELD_UNBOX,
          },
        },
        {
          path: '/physical-install/rack',
          menuText: 'rack',
          exact: true,
          redirectTo: '/physical-install/rack/1',
        },
        {
          path: '/physical-install/rack/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'rack',
          pageProps: {
            steps: [
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_SWITCHED_STEP5,
                steptitle: 'Install Switch Rail Shelves \n and Cable Tray',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_SWITCHED_STEP6,
                steptitle: 'Install Switches',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_STEP1,
                steptitle: 'Install Chassis Rail Shelves',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_STEP2,
                steptitle: 'Install Chassis',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_STEP3,
                steptitle: 'Install HBAs',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_STEP4,
                steptitle: 'Install Drives',
              },
            ],
          },
        },
        {
          path: '/physical-install/cable',
          menuText: 'cable',
          exact: true,
          redirectTo: '/physical-install/cable/1',
        },
        {
          path: '/physical-install/cable/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cable',
          pageProps: {
            steps: [
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP1,
                steptitle: 'Cable Admin Ports',
              },
              {
                steptitle: 'Cable CDMs',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_SWITCHED_STEP2,
                steptitle: 'Cable Data Ports',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP3,
                steptitle: 'Cable Hosts',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP4,
                steptitle: 'Cable Power Supplies',
              },
            ],
          },
        },
        {
          path: '/physical-install/powerOn',
          menuText: 'powerOn',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl: ALLETRAMP_VIDEO_URL.POWERUPANDINIT,
          },
        },
      ],
    },
    {
      path: '/software-config',
      menuText: 'softwareConfig',
      exact: true,
      redirectTo: '/software-config/connectDSCVM',
      submenuItems: [
        {
          path: '/software-config/connectDSCVM',
          menuText: 'connectDSCVM',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/connectDSCandArray',
          menuText: 'connectDSCandArray',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/activateDSC',
          menuText: 'activateDSC',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/setupPCBE',
          menuText: 'setupPCBE',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
      ],
    },
  ];
  return menuItemArray;
}
